/**
 *
 * Asynchronously loads the component for OrderDetailsPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
